'use client';

import { memo as Memo } from 'react';
import Page from '@/components/common/Page';

// HOCs
import { withDataContext, withUIContext } from '@/context';
import Accordion from "@/components/common/Accordion";
import Text from "@/components/common/Text";
import FaqTitle from "@/modules/faq/components/FaqTitle";

const FaqTemplateBase = Memo(({faqs}) => {
  return (
    <Page className="faq-page">
      <div className="faq-container">
        <FaqTitle>faq</FaqTitle>
        <Accordion items={faqs} />
      </div>
    </Page>
  );
});

// ❗ Correct configuration:
// withDataContext(Component, keysToInjectFromContext)
// withUIContext(Component, keysToInjectFromContext)
export default withUIContext(
  withDataContext(FaqTemplateBase, ['selectedLang']),
  ['closePopup']
);
